import { createContext, useContext, useState, useEffect } from 'react';
import { API } from '../lib/api';

const AuthContext = createContext();
const normalizeUser = (userData) => {
  if (!userData) {
    return null;
  }

  const normalizedId = userData.userId || userData.id || null;

  return {
    ...userData,
    id: normalizedId,
    userId: normalizedId,
  };
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawingPackage, setDrawingPackage] = useState(null);
  useEffect(() => {
    API.Drawings.Package().then(({ data }) => setDrawingPackage(data.enabled === true)).catch(() => setDrawingPackage(false));
  }, []);

  // Check if user is logged in via cookie
  useEffect(() => {
    localStorage.removeItem('token');
    const checkAuth = async () => {
      try {
        const response = await API.Authentication.ValidateUser()
        if (response.status === 200) {
          setUser(normalizeUser(response.data.user)); // comes from req.user in backend
        } else {
          setUser(null)
        }
      } catch (error) {
        setUser(null); // not logged in
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData) => {
    const normalizedUser = normalizeUser(userData);

    setUser(normalizedUser);
    localStorage.setItem('user', JSON.stringify(normalizedUser));
    localStorage.setItem('id', normalizedUser.id || "");
    localStorage.setItem("email", normalizedUser.email || "");
    localStorage.setItem("department", normalizedUser.department || "");
    localStorage.setItem("role", normalizedUser.role || "");
    localStorage.setItem("name", normalizedUser.name || "");
  };

  const logout = async () => {
    await API.Authentication.Logout()
    localStorage.clear()
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, drawingPackage }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
